import { useLayoutEffect, useState } from 'react';

export const usePreloadImg = (src) => {
  const [imgSrc, setImgSrc] = useState('');

  useLayoutEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(img.src);
    };
  }, []);

  return [imgSrc];
};
